import awsResourceColumnData from "./awsResourceColumns.json";
import azureResourceColumnData from "./azureResourceColumns.json";
import gcpResourceColumnData from "./gcpResourceColumns.json";
import k8sResourceColumnData from "./k8sResourceColumns.json";
import tencentcloudResourceColumnData from "./tencentcloudResourceColumns.json";

import type { RawColumn } from "./formatColumns";

interface resourceColumns {
  columns: RawColumn[];
}

interface resourceAlias {
  "c7n-alias-for": string;
}

type RawEntry = resourceColumns | resourceAlias;

type LooseObjectResources = Record<string, resourceColumns>;

const raw: Record<string, RawEntry> = {
  ...awsResourceColumnData,
  ...azureResourceColumnData,
  ...gcpResourceColumnData,
  ...k8sResourceColumnData,
  ...tencentcloudResourceColumnData,
};

// Resolve c7n-alias-for entries so consumers always get a resourceColumns value.
export const resourceColumnMapping: LooseObjectResources = Object.fromEntries(
  Object.entries(raw)
    .filter((entry): entry is [string, resourceColumns] => {
      const value = entry[1];
      return !("c7n-alias-for" in value);
    })
    .concat(
      Object.entries(raw)
        .filter((entry): entry is [string, resourceAlias] => {
          return "c7n-alias-for" in entry[1];
        })
        .flatMap(([key, alias]) => {
          const target = raw[alias["c7n-alias-for"]];
          return target && !("c7n-alias-for" in target)
            ? [[key, target] as [string, resourceColumns]]
            : [];
        }),
    ),
);
